import {
    WidgetStrategyWithConfig,
    WidgetStrategyWithStreams,
} from 'widgets/WidgetRegistry';
import { WidgetCategory } from 'widgets/WidgetCategory';
import { PortfolioSelectionRequirements } from 'widgets/PortfolioSelectionRequirements';
import { PlCapsuleConfigState } from './store/config/PlCapsuleConfigState';
import { buildPlCapsuleConfigSlice } from './store/config/configslice';
import { plCapsuleStreamConfig } from './store/data/stream-config';
import { plCapsuleDescription } from './components/description/PlCapsuleDescription';
import { PlCapsule } from './components/PlCapsule';
import { fillsGraphWidgetStrategy } from 'widgets/fillsGraph/FillsGraphWidgetStrategy';

const { initialConfigState } = buildPlCapsuleConfigSlice();

export const plCapsuleWidgetStrategy: WidgetStrategyWithConfig<PlCapsuleConfigState> &
    WidgetStrategyWithStreams = {
    title: 'Profit/Loss',
    supportedHosts: ['tile'],
    reactComponentType: PlCapsule,
    getRequiredOrderColumns: fillsGraphWidgetStrategy.getRequiredOrderColumns,
    categories: [WidgetCategory.TOP],
    description: plCapsuleDescription,
    streamConfigs: [plCapsuleStreamConfig],
    portfolioSelectionRequirements:
        PortfolioSelectionRequirements.SingleSymbolQuantity,
    initialConfigState,
};
